import { render, staticRenderFns } from "./Events_Languages.vue?vue&type=template&id=3ac2fa4a&"
import script from "./Events_Languages.vue?vue&type=script&lang=js&"
export * from "./Events_Languages.vue?vue&type=script&lang=js&"
import style0 from "./Events_Languages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports